import {
    UserDisplayedWidgetClassEnum,
    getApolloErrorUiMessage,
    useCalendarListQuery,
    useGetCalendarReminderWidgetQuery,
} from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';
import { DialogComponent, showDialog } from '@lingoda/dialogs';
import { useDispatch } from '@lingoda/hooks';
import { wasAnyCalendarEverConnected } from '../logic/wasAnyCalendarEverConnected';

export const useShowCalendarConnectionDialog = () => {
    const dispatch = useDispatch();
    const { data, loading } = useCalendarListQuery({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });
    const { data: userWidgetsData } = useGetCalendarReminderWidgetQuery();

    const isVisible = userWidgetsData?.userWidgets?.includes(
        UserDisplayedWidgetClassEnum.CalendarReminderWidget,
    );

    const hasCalendarConnectedAlready = wasAnyCalendarEverConnected(
        data?.calendarList.map(({ status }) => status) || [],
    );

    return {
        shouldShowCalendarConnectDialog: !hasCalendarConnectedAlready && isVisible && !loading,
        showCalendarConnectDialog: () => {
            dispatch(showDialog(DialogComponent.ConnectCalendarDialog, { isOpen: true }));
        },
    };
};
